export var EXPONEA_EVENT_TYPES = Object.freeze({
  INTERESTED_SUBMIT: 'b2c_carSubmitLead',
  SWAP_SUBMIT: 'b2c_carSubmitTradein',
  CF_SUBMIT: 'b2c_carSubmitFinance',
  CF_CONTACT_DATA: 'fin_contactData',
  FIN_CALCULATOR: 'fin_calculator'
});
export var EXPONEA_USER_FLOW = Object.freeze({
  B2C: 'B2C',
  C2B: 'C2B',
  FINANCE: 'FINANCE'
});
export var PANAMERA = 'panamera';